"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import type { CreateWaveDatesConfig } from "@/types/waves.types";
import type { ApiWaveType } from "@/generated/models/ApiWaveType";
import StartDates from "./StartDates";
import Decisions from "./Decisions";
import RollingEndDate from "./RollingEndDate";
import { adjustDatesAfterSubmissionChange, calculateEndDate, validateDateSequence } from "../services/waveDecisionService";
interface CreateWaveDatesProps {
  readonly waveType: ApiWaveType;
  readonly dates: CreateWaveDatesConfig;
  readonly setDates: (dates: CreateWaveDatesConfig) => void;
}
export default function CreateWaveDates(t0) {
  const $ = _c(48);
  const {
    waveType,
    dates,
    setDates
  } = t0;
  const [isRollingMode, setIsRollingMode] = useState(dates.isRolling);
  let t1;
  if ($[0] !== dates.isRolling) {
    t1 = {
      start: true,
      decisions: false,
      rolling: dates.isRolling
    };
    $[0] = dates.isRolling;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [expandedSections, setExpandedSections] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      start: false,
      decisions: false
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [autoCollapsedSections, setAutoCollapsedSections] = useState(t2);
  let t3;
  if ($[3] !== dates.isRolling || $[4] !== expandedSections.rolling) {
    t3 = () => {
      setIsRollingMode(dates.isRolling);
      if (dates.isRolling && !expandedSections.rolling) {
        setExpandedSections(_temp);
      }
    };
    $[3] = dates.isRolling;
    $[4] = expandedSections.rolling;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dates.isRolling) {
    t4 = [dates.isRolling];
    $[6] = dates.isRolling;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== dates || $[9] !== setDates) {
    t5 = () => {
      const validationErrors = validateDateSequence(dates);
      if (validationErrors.length > 0) {
        console.warn("Date validation errors:", validationErrors);
      }
      if (!dates.isRolling) {
        const calculatedEndDate = calculateEndDate(dates);
        if (calculatedEndDate !== dates.endDate) {
          setDates({
            ...dates,
            endDate: calculatedEndDate
          });
        }
      }
    };
    $[8] = dates;
    $[9] = setDates;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== dates.firstDecisionTime || $[12] !== dates.isRolling || $[13] !== dates.submissionStartDate || $[14] !== dates.subsequentDecisions || $[15] !== dates.votingStartDate) {
    t6 = [dates.submissionStartDate, dates.votingStartDate, dates.firstDecisionTime, dates.subsequentDecisions, dates.isRolling];
    $[11] = dates.firstDecisionTime;
    $[12] = dates.isRolling;
    $[13] = dates.submissionStartDate;
    $[14] = dates.subsequentDecisions;
    $[15] = dates.votingStartDate;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  useEffect(t5, t6);
  let t7;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = sectionName => {
      setExpandedSections(prev_0 => ({
        ...prev_0,
        [sectionName]: !prev_0[sectionName]
      }));
    };
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const toggleSection = t7;
  let t8;
  if ($[18] !== autoCollapsedSections.start) {
    t8 = () => {
      if (!autoCollapsedSections.start) {
        setExpandedSections(_temp2);
        setAutoCollapsedSections(_temp3);
      }
    };
    $[18] = autoCollapsedSections.start;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const handleDecisionsInteraction = t8;
  let t9;
  if ($[20] !== dates || $[21] !== setDates) {
    t9 = newDates => {
      if (newDates.submissionStartDate !== dates.submissionStartDate) {
        const adjustedDates = adjustDatesAfterSubmissionChange(dates, newDates.submissionStartDate);
        setDates(adjustedDates);
      } else {
        setDates(newDates);
      }
    };
    $[20] = dates;
    $[21] = setDates;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const handleDateUpdate = t9;
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => toggleSection("start");
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== dates || $[25] !== expandedSections.start || $[26] !== handleDateUpdate || $[27] !== waveType) {
    t11 = <StartDates waveType={waveType} dates={dates} setDates={handleDateUpdate} isExpanded={expandedSections.start} setIsExpanded={t10} />;
    $[24] = dates;
    $[25] = expandedSections.start;
    $[26] = handleDateUpdate;
    $[27] = waveType;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== expandedSections.rolling) {
    t12 = isRolling => {
      setIsRollingMode(isRolling);
      if (isRolling && !expandedSections.rolling) {
        setExpandedSections(_temp4);
      }
    };
    $[29] = expandedSections.rolling;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => toggleSection("decisions");
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== dates || $[33] !== expandedSections.decisions || $[34] !== handleDecisionsInteraction || $[35] !== isRollingMode || $[36] !== setDates || $[37] !== t12) {
    t14 = <Decisions dates={dates} setDates={setDates} isRollingMode={isRollingMode} setIsRollingMode={t12} isExpanded={expandedSections.decisions} setIsExpanded={t13} onInteraction={handleDecisionsInteraction} />;
    $[32] = dates;
    $[33] = expandedSections.decisions;
    $[34] = handleDecisionsInteraction;
    $[35] = isRollingMode;
    $[36] = setDates;
    $[37] = t12;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== dates || $[40] !== expandedSections.rolling || $[41] !== isRollingMode || $[42] !== setDates) {
    t15 = dates.subsequentDecisions.length > 0 && (isRollingMode || dates.isRolling) && <RollingEndDate dates={dates} setDates={setDates} isRollingMode={isRollingMode} isExpanded={expandedSections.rolling} setIsExpanded={() => toggleSection("rolling")} />;
    $[39] = dates;
    $[40] = expandedSections.rolling;
    $[41] = isRollingMode;
    $[42] = setDates;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t11 || $[45] !== t14 || $[46] !== t15) {
    t16 = <div className="tw-space-y-4">{t11}{t14}{t15}</div>;
    $[44] = t11;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  return t16;
}
function _temp4(prev_3) {
  return {
    ...prev_3,
    rolling: true
  };
}
function _temp3(prev_2) {
  return {
    ...prev_2,
    start: true
  };
}
function _temp2(prev_1) {
  return {
    ...prev_1,
    start: false
  };
}
function _temp(prev) {
  return {
    ...prev,
    rolling: true
  };
}